import React, { useEffect, useState } from "react";
import {Form, message} from "antd";
import {SDrawerOrModal, SGeneralForms} from "shj-components";

import { productExportProductRelation } from "@/services/product.ts";
import { getEnums } from "@/services/homeService.ts";
import { fileConfirm } from "@/utils/file.ts";
import { fileDownload } from "@/utils/download.ts";
import UrlConfig from "@/api/UrlConfigs.ts";
import { METHODS } from "shj-utils";

const ExportModal = (props) => {
  const { open, onClose, spuData } = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const getOptions = async () => {
    const exportEnum = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.ProductExportEnum');
    form.setFieldsValue({ productExportEnums: exportEnum?.map?.(item => item.key) })
    return { exportEnum: exportEnum?.map?.(item => ({...item, label: item.description, value: item.key})) }
  }

  const onFinish = async () => {
      const values = await form.validateFields();
      const productExportEnums = values.productExportEnums || [];
      if (productExportEnums.length === 0) {
        message.warning('请至少选择一种导出类型');
        return;
      }
      setLoading(true);
        fileDownload(UrlConfig.PlusProductWeb.ProductExportProductRelation, {
          method: METHODS.POST,
          data: { productId: spuData.id, productExportEnums },
          error: false,
          timeout: 3 * 60 * 1000,
          })
          .then(() => {
            message.success('导出成功');
            onClose();
          })
          .catch(async(err) => {
            if (err instanceof Blob || Object.prototype.toString.call(err) === '[object Blob]') {
              try {
                const text = await err.text();
                const jsonData = JSON.parse(text);
                message.error(jsonData.message);
              } catch (error) {
                return err;
              }
            }
          })
          .finally(() => setLoading(false))
  }

    return <>
      <SDrawerOrModal
        title={'导出'}
        mode="modal"
        width={550}
        okText={'确定'}
        open={open}
        loading={loading}
        onCancel={onClose}
        onOk={onFinish}
      >
        <SGeneralForms
          formConfig={{ form }}
          httpOptionsFn={getOptions}
          configs={[{
            formItem: [
              {
                spanCol: 24,
                label: '',
                name: 'productExportEnums',
                type: 'checkbox',
                data: 'exportEnum',
                rules: [{ required: true, message: '请至少选择一种导出类型' }],
              },
            ]
          }]}
        />
      </SDrawerOrModal>
    </>
}

export default ExportModal